<template>
    <div class="d-flex flex-row mb-3 pb-3 border-bottom">
        <router-link tag="a" :to="detailPath">
            <img :src="data.thumb" :alt="data.title" class="img-thumbnail border-0 list-thumbnail align-self-center"/>
        </router-link>
        <div class="pl-3 pr-2">
            <router-link tag="a" :to="detailPath">
                <p class="font-weight-medium mb-0 ">{{ data.title }}</p>
                <!-- <p class="text-muted mb-1 text-small">Store : {{ data.store }}</p> -->
                <p class="text-muted mb-1 text-small">Position : PC</p>
                <p class="text-muted mb-1 text-small">Store : {{ data.store }}</p>
                <p class="text-muted mb-1 text-small">Province : {{ data.province }}</p>
            </router-link>
        </div>
        <div id="mybutton">
          <div class="d-flex">
            <div style="cursor: pointer;" class="align-self-center list-thumbnail-letters rounded-circle m-2" @click="onSave()" >{{ $t("menu.save")}}</div>
          </div>
        </div>
    </div>
</template>
<script>
import Stars from '@/components/Common/Stars'
export default {
  components: {
    Stars
  },
  props: ['data', 'detailPath']
}
</script>
<style scope>

.btn-group > .btn:first-child {
    margin-left: 0;
    width: 100%;
}
.btn-group > .btn:first-child {
    margin-left: 0;
    width: 100%;
    text-align: left;
}
.dropdown-toggle::after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid;
    border-right: .3em solid transparent;
    border-bottom: 0;
    border-left: .3em solid transparent;
    text-align: right;
    float: right;
    margin-top: 5px;
}
</style>
